import {getData} from "../api/get-data";

export const setFavorite = (itemId, isCheck, resolveHandler, rejectHandler = () => {}) => {
  getData({
    [`set_favorite`]: {
      [`item_id`]: itemId,
      [`action`]: isCheck ? `add` : `reduce`,
    }
  })
  .then((response) => {
    resolveHandler(response);
  })
  .catch(() => {
    rejectHandler();
  });
};
